@if (dataSource && !eventFinished) {
  <div class="sub-event-participant bold">
    <div class="priority-info">{{'event.priorityInfo' | translate}}</div>
    @if (eventData.allowSameTimeSubEvent) {
      <div class="priority-info red">{{'event.checkPriority' | translate}}</div>
    }
    <mat-table [dataSource]="dataSource">
      @for (disCol of displayedColumns; track disCol; let colIndex = $index) {
        <ng-container matColumnDef="{{disCol}}">
          <mat-header-cell *matHeaderCellDef class="table-header-columns">
            @if (disCol === 'edit' || disCol === 'event.participants') {
              {{disCol | translate}}
            }
            @if (disCol !== 'edit' && disCol !== 'event.participants') {
              {{displayedColumnsDescription[disCol]}}
              @if (maxParticipants[disCol] || minParticipants[disCol]) {
                <span>
                  &nbsp;({{minParticipants[disCol]}}/{{maxParticipants[disCol]}})
                </span>
              }
              <!--          <mat-icon *ngIf="maxParticipants[disCol]"-->
              <!--                    [matTooltip]="('event.max_participants' | translate) + ': ' + maxParticipants[disCol]">-->
              <!--            info-->
            <!--          </mat-icon>-->
          }
        </mat-header-cell>
        <mat-cell *matCellDef="let element " class="table-columns"
          [style.background-color]="maxParticipantsError ? getColor(disCol) : getColorByTime(element, disCol)">
          @if (disCol !== 'edit' && disCol !== 'event.participants' && !element.editing) {
            <div class="event-priority" [style.color]="element | subEventPriority:disCol:'color'">
              {{element | subEventPriority:disCol:'priority' }}
              @if (+element.highPriorityEvent === +disCol && +element.highPriority !== 1) {
                <mat-icon class="priority-icon" [matTooltip]="'event.highest_priority' | translate">arrow_upward</mat-icon>
              }
            </div>
          }
          @if (disCol !== 'edit' && disCol !== 'event.participants' && element.editing) {
            <div
              class="select-container" style="width: 100px">
              <mat-select (selectionChange)="changeSelect(element, disCol, $event.value)"
                [value]="element | subEventPriority:disCol:'priority'">
                @for (pr of this.priorityRange[disCol]; track pr) {
                  <mat-option [value]="pr">
                    {{pr}}
                  </mat-option>
                }
              </mat-select>
            </div>
          }
          @if (disCol === 'event.participants') {
            {{element.name}}
          }
          @if (disCol === 'edit') {
            @if (!editInProgress) {
              <mat-icon (click)="editSubEventParticipant(element)">edit</mat-icon>
            }
            @if (editInProgress && element.editing) {
              <mat-icon
              (click)="saveEditSubEventParticipant(element)">save</mat-icon>
            }
            @if (editInProgress && element.editing) {
              <mat-icon
              (click)="cancelEditSubEventParticipant(element)">cancel</mat-icon>
            }
          }
        </mat-cell>
      </ng-container>
    }
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
  <div class="buttons flex">
    <div class="buttons">
      <span [matTooltip]="(wasEdited || editInProgress) ? ('event.unsaved_changes_error' | translate) :
              maxParticipantsError ? ('event.max_sub_event_participant_error' | translate) : ('event.finish_booking_msg' | translate)">
        <button mat-raised-button (click)="finishBooking()"
        [disabled]="wasEdited || editInProgress || maxParticipantsError">{{'event.finish_booking' | translate}}</button>
      </span>
      <span [matTooltip]="('event.unsaved_changes_error' | translate)"
        [matTooltipDisabled]="!wasEdited && !editInProgress">
        @if (maxParticipantsError) {
          <button mat-raised-button (click)="autoFix()"
          [disabled]="wasEdited || editInProgress" >{{'event.auto_change' | translate}}</button>
        }
      </span>
    </div>
    <div class="buttons right">
      <button mat-raised-button (click)="saveChanges()" [disabled]="!wasEdited || editInProgress">{{'main.save' | translate}}</button>
      <button mat-raised-button (click)="cancelChanges()" [disabled]="!wasEdited || editInProgress">{{'button.cancel' | translate}}</button>
    </div>
  </div>
</div>
}
@if (eventFinished) {
  <div class="sub-event-participant">
    <div class="send-notification">
      <button mat-raised-button (click)="sendNotification()">{{'event.send_notification' | translate}}</button>
    </div>
    @for (subEvent of subEvents; track subEvent) {
      <div class="sub-event">
        <div class="title">
          {{subEvent.title}}
          <img (click)="downloadExcel(subEvent)" src="../../../../../assets/images/excel.png"/>
        </div>
        <div class="sub-title">
          @if (subEvent?.date) {
            <div>{{'event-preview.date' | translate}}: {{subEvent?.date}}</div>
          }
          @if (subEvent?.fromTime) {
            <div>{{'event.from_time' | translate}}: {{subEvent?.fromTime}}</div>
          }
          @if (subEvent?.toTime) {
            <div>{{'event.to_time' | translate}}: {{subEvent?.toTime}}</div>
          }
          @if (subEvent?.minParticipants) {
            <div>{{'event.min_participant' | translate}}: {{subEvent?.minParticipants}}</div>
          }
          @if (subEvent?.maxParticipants) {
            <div>{{'event.max_participant' | translate}}: {{subEvent?.maxParticipants}}</div>
          }
        </div>
        <div class="participants">
          <ul>
            @for (part of subEvent.subEventBooking; track part) {
              @if (part.frontUser) {
                <li>{{part.frontUser.firstName}} {{part.frontUser.lastName}}</li>
              }
              @if (part.guestUsers) {
                <li>{{part.guestUsers.firstName}} {{part.guestUsers.lastName}}</li>
              }
            }
          </ul>
        </div>
      </div>
    }
  </div>
}
